import { Space, Tag, Tooltip, Typography } from 'antd';

const { Text } = Typography;

export type MemoryCitation = {
  id: string;
  title: string;
  reasons: string[];
};

export function MemoryReasonTags({ items }: { items: MemoryCitation[] }) {
  if (!items.length) return null;
  return (
    <div style={{ marginBottom: 8 }}>
      <Text type="secondary" style={{ fontSize: 12, display: 'block', marginBottom: 4 }}>
        Validated memory used for grounding
      </Text>
      <Space direction="vertical" size={4} style={{ width: '100%' }}>
        {items.map((m) => (
          <div key={m.id}>
            <Text style={{ fontSize: 12 }}>{m.title}</Text>
            <div style={{ marginTop: 2 }}>
              {(m.reasons || []).map((r) => (
                <Tooltip key={r} title="Why this memory surfaced">
                  <Tag color="blue" style={{ marginBottom: 2, fontSize: 11 }}>
                    {r}
                  </Tag>
                </Tooltip>
              ))}
            </div>
          </div>
        ))}
      </Space>
    </div>
  );
}
